import type { ApiRoute, NoBody, NoPathParams } from "../api"
import type { DetailsEquipmentStageView } from "./details/DetailsEquipmentStageView"

export interface GetDetailsEquipmentStageQueryParams {
	"inventory-id": string
}

export const getDetailsEquipmentStageRoute: ApiRoute<
	NoPathParams,
	GetDetailsEquipmentStageQueryParams,
	NoBody,
	DetailsEquipmentStageView
> = {
	buildUrl: () => "/details/equipment/stage",
	method: "get",
	path: "/details/equipment/stage",
}
